import React, { useState, useEffect } from 'react';
import {
  Box, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button,
  IconButton, Typography, TextField, Dialog,
  DialogTitle, DialogContent, DialogActions,
  MenuItem, Chip, Card, CardContent, Grid,
  CircularProgress, Alert, FormControl, InputLabel,
  Select, Tooltip, Avatar, Badge, Divider,
  List, ListItem, ListItemText, ListItemAvatar,
  Accordion, AccordionSummary, AccordionDetails,
  InputAdornment, Tabs, Tab, Fade,
  Stepper, Step, StepLabel
} from '@mui/material';
import {
  Edit, Delete, Add, Receipt,
  Search, Restaurant, EventSeat,
  Visibility, VisibilityOff, ShoppingCart,
  CheckCircle, Cancel, AccessTime,
  AttachMoney, Paid, Print,
  AddCircle, RemoveCircle, ExpandMore,
  LocalOffer, Fastfood, TableRestaurant,
  Person, Schedule, CreditCard,
  MonetizationOn, RoomService,
  TrendingUp, Refresh, QrCode,
  AssignmentTurnedIn, AssignmentLate,
  AddShoppingCart, RemoveShoppingCart,
  ArrowForward, ArrowBack, DeliveryDining
} from '@mui/icons-material';
import { commandeAPI, tableAPI } from '../../../services/restaurantAPI';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const CommandesPage = () => {
  const [commandes, setCommandes] = useState([]);
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [openPaiementDialog, setOpenPaiementDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTable, setSelectedTable] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedType, setSelectedType] = useState('all');
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCommande, setSelectedCommande] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  
  // Pagination
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    page: 1,
    pageSize: 10
  });

  // Form data
  const [formData, setFormData] = useState({
    table: '',
    type_commande: 'sur_place',
    nom_client: '',
    notes: '',
    statut: 'ouverte'
  });

  // Paiement data
  const [paiementData, setPaiementData] = useState({
    methode_paiement: 'especes',
    montant_recu: '',
    monnaie: 0
  });

  // Items pour nouvelle commande
  const [items, setItems] = useState([]);
  const [addingItem, setAddingItem] = useState(false);
  const [newItem, setNewItem] = useState({
    plat: '',
    boisson: '',
    type: 'plat',
    quantite: 1,
    prix_unitaire: 0,
    notes: ''
  });

  // Steps pour le wizard de commande
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Sélection', 'Items', 'Récapitulatif'];

  // Options
  const typeCommandeOptions = [
    { value: 'sur_place', label: 'Sur place', icon: <Restaurant /> },
    { value: 'emporter', label: 'À emporter', icon: <ShoppingCart /> },
    { value: 'livraison', label: 'Livraison', icon: <DeliveryDining /> },
  ];

  const statutOptions = [
    { value: 'ouverte', label: 'Ouverte', color: 'primary' },
    { value: 'en_preparation', label: 'En préparation', color: 'warning' },
    { value: 'servie', label: 'Servie', color: 'info' },
    { value: 'payee', label: 'Payée', color: 'success' },
    { value: 'annulee', label: 'Annulée', color: 'error' },
  ];

  const methodePaiementOptions = [
    { value: 'especes', label: 'Espèces', icon: <MonetizationOn /> },
    { value: 'carte', label: 'Carte bancaire', icon: <CreditCard /> },
    { value: 'mobile', label: 'Paiement mobile', icon: <QrCode /> },
    { value: 'compte', label: 'Sur compte', icon: <AssignmentTurnedIn /> },
  ];

  // Statistiques
  const [stats, setStats] = useState({
    total: 0,
    ouvertes: 0,
    en_preparation: 0,
    servies: 0,
    payees: 0,
    chiffreAffaires: 0,
    montantMoyen: 0
  });

  // Simuler des plats et boissons (à remplacer par votre API)
  const [plats, setPlats] = useState([
    { id: 1, nom: 'Pizza Margherita', prix: 12.50, categorie: 'Pizza' },
    { id: 2, nom: 'Pizza Pepperoni', prix: 14.00, categorie: 'Pizza' },
    { id: 3, nom: 'Salade César', prix: 8.50, categorie: 'Entrée' },
    { id: 4, nom: 'Steak Frites', prix: 16.00, categorie: 'Plat' },
    { id: 5, nom: 'Pâtes Carbonara', prix: 13.50, categorie: 'Plat' },
  ]);

  const [boissons, setBoissons] = useState([
    { id: 1, nom: 'Coca-Cola', prix: 3.00, categorie: 'Soft' },
    { id: 2, nom: 'Eau Minérale', prix: 2.00, categorie: 'Soft' },
    { id: 3, nom: 'Vin Rouge', prix: 5.00, categorie: 'Alcool' },
    { id: 4, nom: 'Bière', prix: 4.00, categorie: 'Alcool' },
    { id: 5, nom: 'Cocktail', prix: 8.00, categorie: 'Cocktail' },
  ]);

  // Fetch data
  const fetchCommandes = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await commandeAPI.getAll();
      
      let commandesData = [];
      let paginationData = {
        count: 0,
        next: null,
        previous: null
      };
      
      // Gestion des formats de réponse
      if (response.data && Array.isArray(response.data)) {
        commandesData = response.data;
        paginationData.count = response.data.length;
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        commandesData = response.data.results;
        paginationData = {
          count: response.data.count || 0,
          next: response.data.next,
          previous: response.data.previous
        };
      } else if (response.pagination) {
        commandesData = response.data;
        paginationData = response.pagination;
      }
      
      setCommandes(commandesData);
      setPagination(prev => ({
        ...prev,
        ...paginationData
      }));
      
      calculateStats(commandesData);
      
    } catch (error) {
      console.error('Erreur fetchCommandes:', error);
      handleError(error, 'Erreur lors du chargement des commandes');
    } finally {
      setLoading(false);
    }
  };

  const fetchTables = async () => {
    try {
      const response = await tableAPI.getAll();
      let tablesData = [];
      
      if (response.data && Array.isArray(response.data)) {
        tablesData = response.data;
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        tablesData = response.data.results;
      }
      
      // Filtrer tables libres ou occupées (pour commande)
      tablesData = tablesData.filter(table => 
        table.statut === 'libre' || table.statut === 'occupee'
      );
      
      setTables(tablesData);
    } catch (error) {
      console.error('Erreur fetchTables:', error);
      toast.error('Erreur lors du chargement des tables');
    }
  };

  useEffect(() => {
    fetchCommandes();
    fetchTables();
  }, []);

  const handleError = (error, defaultMessage) => {
    let errorMessage = defaultMessage;
    
    if (error.response?.data) {
      if (error.response.data.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    setError(errorMessage);
    toast.error(errorMessage);
  };

  const calculateStats = (commandesData) => {
    const total = commandesData.length;
    const ouvertes = commandesData.filter(c => c.statut === 'ouverte').length;
    const en_preparation = commandesData.filter(c => c.statut === 'en_preparation').length;
    const servies = commandesData.filter(c => c.statut === 'servie').length;
    const payees = commandesData.filter(c => c.statut === 'payee').length;
    
    const chiffreAffaires = commandesData
      .filter(c => c.statut === 'payee')
      .reduce((sum, c) => sum + parseFloat(c.montant_total || 0), 0);
    
    const montantMoyen = payees > 0 ? chiffreAffaires / payees : 0;
    
    setStats({
      total,
      ouvertes,
      en_preparation,
      servies,
      payees,
      chiffreAffaires,
      montantMoyen
    });
  };

  const getTableNumber = (tableId) => {
    const table = tables.find(t => t.id === tableId);
    return table ? table.numero : 'N/A';
  };

  const getStatutColor = (statut) => {
    const option = statutOptions.find(s => s.value === statut);
    return option ? option.color : 'default';
  };

  const getStatutLabel = (statut) => {
    const option = statutOptions.find(s => s.value === statut);
    return option ? option.label : statut;
  };

  const getStatutIcon = (statut) => {
    switch (statut) {
      case 'ouverte': return <AccessTime />;
      case 'en_preparation': return <Schedule />;
      case 'servie': return <CheckCircle />;
      case 'payee': return <Paid />;
      case 'annulee': return <Cancel />;
      default: return <AccessTime />;
    }
  };

  const getTypeCommandeIcon = (type) => {
    const option = typeCommandeOptions.find(t => t.value === type);
    return option ? option.icon : <Restaurant />;
  };

  const getTypeCommandeLabel = (type) => {
    const option = typeCommandeOptions.find(t => t.value === type);
    return option ? option.label : type;
  };

  const getMethodePaiementIcon = (methode) => {
    const option = methodePaiementOptions.find(m => m.value === methode);
    return option ? option.icon : <AttachMoney />;
  };

  const getMethodePaiementLabel = (methode) => {
    const option = methodePaiementOptions.find(m => m.value === methode);
    return option ? option.label : methode;
  };

  // Format date
  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd/MM/yyyy HH:mm', { locale: fr });
    } catch (e) {
      return dateString;
    }
  };

  // Form handlers
  const resetForm = () => {
    setFormData({
      table: '',
      type_commande: 'sur_place',
      nom_client: '',
      notes: '',
      statut: 'ouverte'
    });
    setItems([]);
    setActiveStep(0);
    setIsEditing(false);
  };

  const handleOpenDialog = (commande = null) => {
    if (commande) {
      setFormData({
        table: commande.table || '',
        type_commande: commande.type_commande || 'sur_place',
        nom_client: commande.nom_client || '',
        notes: commande.notes || '',
        statut: commande.statut || 'ouverte'
      });
      setItems(commande.lignes || []);
      setIsEditing(true);
    } else {
      resetForm();
    }
    setOpenDialog(true);
  };

  const handleOpenDetails = (commande) => {
    setSelectedCommande(commande);
    setOpenDetailsDialog(true);
  };

  const handleOpenPaiement = (commande) => {
    setSelectedCommande(commande);
    setPaiementData({
      methode_paiement: 'especes',
      montant_recu: commande.montant_total || '',
      monnaie: 0
    });
    setOpenPaiementDialog(true);
  };

  const handleAddItem = () => {
    if (!newItem.type || (!newItem.plat && !newItem.boisson) || newItem.quantite < 1) {
      toast.error('Veuillez remplir tous les champs requis');
      return;
    }

    let itemToAdd = { ...newItem };
    
    if (newItem.type === 'plat') {
      const plat = plats.find(p => p.id === parseInt(newItem.plat));
      if (plat) {
        itemToAdd.nom = plat.nom;
        itemToAdd.prix_unitaire = plat.prix;
      }
    } else {
      const boisson = boissons.find(b => b.id === parseInt(newItem.boisson));
      if (boisson) {
        itemToAdd.nom = boisson.nom;
        itemToAdd.prix_unitaire = boisson.prix;
      }
    }

    itemToAdd.total = itemToAdd.prix_unitaire * itemToAdd.quantite;
    itemToAdd.id = Date.now(); // ID temporaire

    setItems([...items, itemToAdd]);
    setNewItem({
      plat: '',
      boisson: '',
      type: 'plat',
      quantite: 1,
      prix_unitaire: 0,
      notes: ''
    });
    setAddingItem(false);
    toast.success('Item ajouté à la commande');
  };

  const handleRemoveItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  const handleSubmit = async () => {
    if (!formData.table && formData.type_commande === 'sur_place') {
      toast.error('Veuillez sélectionner une table');
      return;
    }

    if (items.length === 0) {
      toast.error('Veuillez ajouter au moins un item à la commande');
      return;
    }

    setSubmitting(true);

    try {
      const commandeData = {
        ...formData,
        table: formData.table || null,
        montant_total: items.reduce((sum, item) => sum + item.total, 0),
        sous_total: items.reduce((sum, item) => sum + item.total, 0),
        remise: 0
      };

      let response;
      if (isEditing && formData.id) {
        response = await commandeAPI.update(formData.id, commandeData);
        toast.success('Commande modifiée avec succès');
      } else {
        // Utiliser createWithItems si disponible, sinon create
        response = await commandeAPI.create(commandeData);
        toast.success('Commande créée avec succès');
      }

      setOpenDialog(false);
      resetForm();
      fetchCommandes();
    } catch (error) {
      handleError(error, 'Erreur lors de l\'enregistrement');
    } finally {
      setSubmitting(false);
    }
  };

  const handlePaiement = async () => {
    if (!selectedCommande) return;

    if (!paiementData.montant_recu || parseFloat(paiementData.montant_recu) < parseFloat(selectedCommande.montant_total || 0)) {
      toast.error('Le montant reçu doit être au moins égal au montant total');
      return;
    }

    setSubmitting(true);

    try {
      await commandeAPI.payer(selectedCommande.id, paiementData);
      toast.success('Paiement enregistré avec succès');
      setOpenPaiementDialog(false);
      fetchCommandes();
    } catch (error) {
      handleError(error, 'Erreur lors du paiement');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDemanderAddition = async (id) => {
    try {
      await commandeAPI.demanderAddition(id);
      toast.success('Addition demandée avec succès');
      fetchCommandes();
    } catch (error) {
      handleError(error, 'Erreur lors de la demande d\'addition');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette commande ?')) {
      try {
        await commandeAPI.delete(id);
        toast.success('Commande supprimée avec succès');
        fetchCommandes();
      } catch (error) {
        handleError(error, 'Erreur lors de la suppression');
      }
    }
  };

  const handleAnnuler = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir annuler cette commande ?')) {
      try {
        await commandeAPI.patch(id, { statut: 'annulee' });
        toast.success('Commande annulée avec succès');
        fetchCommandes();
      } catch (error) {
        handleError(error, 'Erreur lors de l\'annulation');
      }
    }
  };

  const handleNextStep = () => {
    if (activeStep === 0 && !formData.table && formData.type_commande === 'sur_place') {
      toast.error('Veuillez sélectionner une table');
      return;
    }
    setActiveStep(prev => prev + 1);
  };

  const handlePrevStep = () => {
    setActiveStep(prev => prev - 1);
  };

  const filteredCommandes = commandes.filter(commande => {
    const matchesSearch = 
      commande.numero?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      commande.nom_client?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      getTableNumber(commande.table)?.toLowerCase().includes(searchTerm.toLowerCase()) || false;
    
    const matchesTable = selectedTable === 'all' || commande.table === parseInt(selectedTable);
    const matchesStatus = selectedStatus === 'all' || commande.statut === selectedStatus;
    const matchesType = selectedType === 'all' || commande.type_commande === selectedType;
    
    return matchesSearch && matchesTable && matchesStatus && matchesType;
  });

  const totalItems = items.reduce((sum, item) => sum + item.quantite, 0);
  const totalAmount = items.reduce((sum, item) => sum + item.total, 0);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" p={3}>
        <CircularProgress />
        <Typography ml={2}>Chargement des commandes...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, backgroundColor: 'background.default', minHeight: '100vh' }}>
      {/* Header avec statistiques */}
      <Box mb={4}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom fontWeight="bold">
              <Receipt sx={{ mr: 2, verticalAlign: 'middle' }} />
              Gestion des Commandes
            </Typography>
            <Typography color="textSecondary" variant="body1">
              Gérez les commandes et le service en salle
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
            <TextField
              placeholder="Rechercher une commande..."
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />,
                sx: { borderRadius: 1 }
              }}
              sx={{ width: 300 }}
            />
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => handleOpenDialog()}
              sx={{ height: 40, px: 3, borderRadius: 1 }}
            >
              Nouvelle Commande
            </Button>
            <Button
              variant="outlined"
              startIcon={<Refresh />}
              onClick={fetchCommandes}
              sx={{ borderRadius: 1 }}
            >
              Actualiser
            </Button>
          </Grid>
        </Grid>

        {/* Cartes statistiques */}
        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} sm={6} md={2}>
            <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                  Total Commandes
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  {stats.total}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                  En cours
                </Typography>
                <Typography variant="h4" fontWeight="bold" color="primary.main">
                  {stats.ouvertes + stats.en_preparation}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                  À servir
                </Typography>
                <Typography variant="h4" fontWeight="bold" color="warning.main">
                  {stats.servies}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                  Payées
                </Typography>
                <Typography variant="h4" fontWeight="bold" color="success.main">
                  {stats.payees}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                  Chiffre d'affaires
                </Typography>
                <Typography variant="h4" fontWeight="bold" color="info.main">
                  {stats.chiffreAffaires.toFixed(2)} 
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom variant="subtitle2">
                  Panier moyen
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  {stats.montantMoyen.toFixed(2)} 
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Filtres */}
      <Box mb={3} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
        <Box display="flex" gap={2} flexWrap="wrap">
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Table</InputLabel>
            <Select
              value={selectedTable}
              label="Table"
              onChange={(e) => setSelectedTable(e.target.value)}
              sx={{ borderRadius: 1 }}
            >
              <MenuItem value="all">Toutes les tables</MenuItem>
              {tables.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <TableRestaurant fontSize="small" />
                    Table {table.numero} ({table.statut})
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Statut</InputLabel>
            <Select
              value={selectedStatus}
              label="Statut"
              onChange={(e) => setSelectedStatus(e.target.value)}
              sx={{ borderRadius: 1 }}
            >
              <MenuItem value="all">Tous les statuts</MenuItem>
              {statutOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Chip 
                    label={option.label} 
                    size="small" 
                    color={option.color}
                    variant="outlined"
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={selectedType}
              label="Type"
              onChange={(e) => setSelectedType(e.target.value)}
              sx={{ borderRadius: 1 }}
            >
              <MenuItem value="all">Tous les types</MenuItem>
              {typeCommandeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Box display="flex" alignItems="center" gap={1}>
                    {option.icon}
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
          <Tab icon={<Receipt />} label="Toutes" />
          <Tab icon={<AccessTime />} label="En cours" />
          <Tab icon={<Paid />} label="Payées" />
        </Tabs>
      </Box>

      {/* Tableau des commandes */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden', mb: 3 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: 'action.hover' }}>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }}>N° Commande</TableCell>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }}>Table/Client</TableCell>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }}>Montant</TableCell>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }}>Statut</TableCell>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold', py: 2 }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCommandes.length > 0 ? (
                filteredCommandes.map((commande) => (
                  <TableRow key={commande.id} hover>
                    <TableCell sx={{ py: 2 }}>
                      <Typography fontWeight="bold" color="primary">
                        {commande.numero}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ py: 2 }}>
                      {commande.table ? (
                        <Box display="flex" alignItems="center" gap={1}>
                          <TableRestaurant fontSize="small" />
                          <Typography>Table {getTableNumber(commande.table)}</Typography>
                        </Box>
                      ) : (
                        <Box display="flex" alignItems="center" gap={1}>
                          <Person fontSize="small" />
                          <Typography>{commande.nom_client || 'Client'}</Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell sx={{ py: 2 }}>
                      <Box display="flex" alignItems="center" gap={1}>
                        {getTypeCommandeIcon(commande.type_commande)}
                        <Typography variant="body2">
                          {getTypeCommandeLabel(commande.type_commande)}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: 2 }}>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <AttachMoney fontSize="small" />
                        <Typography fontWeight="bold">
                          {parseFloat(commande.montant_total || 0).toFixed(2)} 
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: 2 }}>
                      <Chip
                        icon={getStatutIcon(commande.statut)}
                        label={getStatutLabel(commande.statut)}
                        color={getStatutColor(commande.statut)}
                        size="small"
                        sx={{ borderRadius: 1 }}
                      />
                    </TableCell>
                    <TableCell sx={{ py: 2 }}>
                      <Typography variant="body2">
                        {formatDate(commande.date_commande)}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ py: 2 }} align="center">
                      <Box display="flex" justifyContent="center" gap={1}>
                        <Tooltip title="Détails">
                          <IconButton
                            color="info"
                            size="small"
                            onClick={() => handleOpenDetails(commande)}
                          >
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                        
                        {commande.statut === 'servie' && (
                          <Tooltip title="Payer">
                            <IconButton
                              color="success"
                              size="small"
                              onClick={() => handleOpenPaiement(commande)}
                            >
                              <Paid />
                            </IconButton>
                          </Tooltip>
                        )}
                        
                        {commande.statut === 'ouverte' && (
                          <Tooltip title="Demander addition">
                            <IconButton
                              color="warning"
                              size="small"
                              onClick={() => handleDemanderAddition(commande.id)}
                            >
                              <Receipt />
                            </IconButton>
                          </Tooltip>
                        )}
                        
                        {commande.statut !== 'payee' && commande.statut !== 'annulee' && (
                          <Tooltip title="Annuler">
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => handleAnnuler(commande.id)}
                            >
                              <Cancel />
                            </IconButton>
                          </Tooltip>
                        )}
                        
                        {commande.statut !== 'payee' && (
                          <Tooltip title="Supprimer">
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => handleDelete(commande.id)}
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                      <Receipt sx={{ fontSize: 60, color: 'text.disabled' }} />
                      <Typography variant="body1" color="textSecondary">
                        Aucune commande trouvée
                      </Typography>
                      <Button
                        variant="outlined"
                        startIcon={<Add />}
                        onClick={() => handleOpenDialog()}
                        sx={{ mt: 1 }}
                      >
                        Créer une commande
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Dialog de création/édition */}
      <Dialog 
        open={openDialog} 
        onClose={() => !submitting && setOpenDialog(false)} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Receipt />
            <Typography variant="h6">
              {isEditing ? 'Modifier la Commande' : 'Nouvelle Commande'}
            </Typography>
          </Box>
        </DialogTitle>
        
        <DialogContent>
          <Stepper activeStep={activeStep} sx={{ mb: 4, mt: 2 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {activeStep === 0 && (
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Type de commande</InputLabel>
                    <Select
                      value={formData.type_commande}
                      label="Type de commande"
                      onChange={(e) => setFormData({...formData, type_commande: e.target.value})}
                    >
                      {typeCommandeOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Box display="flex" alignItems="center" gap={1}>
                            {option.icon}
                            {option.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {formData.type_commande === 'sur_place' && (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Table</InputLabel>
                      <Select
                        value={formData.table}
                        label="Table"
                        onChange={(e) => setFormData({...formData, table: e.target.value})}
                      >
                        {tables.filter(t => t.statut === 'libre' || t.statut === 'occupee').map((table) => (
                          <MenuItem key={table.id} value={table.id}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <TableRestaurant />
                              Table {table.numero} ({table.capacite} places)
                              <Chip 
                                label={table.statut} 
                                size="small" 
                                color={table.statut === 'libre' ? 'success' : 'error'}
                                sx={{ ml: 1 }}
                              />
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {formData.type_commande !== 'sur_place' && (
                  <Grid item xs={12}>
                    <TextField
                      label="Nom du client"
                      fullWidth
                      value={formData.nom_client}
                      onChange={(e) => setFormData({...formData, nom_client: e.target.value})}
                      placeholder="Nom du client"
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    label="Notes"
                    multiline
                    rows={2}
                    fullWidth
                    value={formData.notes}
                    onChange={(e) => setFormData({...formData, notes: e.target.value})}
                    placeholder="Instructions spéciales, allergies, etc."
                  />
                </Grid>
              </Grid>
            </Box>
          )}

          {activeStep === 1 && (
            <Box>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h6">Items de la commande</Typography>
                <Button
                  variant="contained"
                  startIcon={<AddCircle />}
                  onClick={() => setAddingItem(true)}
                >
                  Ajouter un item
                </Button>
              </Box>

              {addingItem && (
                <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <FormControl fullWidth>
                        <InputLabel>Type</InputLabel>
                        <Select
                          value={newItem.type}
                          label="Type"
                          onChange={(e) => setNewItem({...newItem, type: e.target.value})}
                        >
                          <MenuItem value="plat">Plat</MenuItem>
                          <MenuItem value="boisson">Boisson</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>{newItem.type === 'plat' ? 'Plat' : 'Boisson'}</InputLabel>
                        <Select
                          value={newItem.type === 'plat' ? newItem.plat : newItem.boisson}
                          label={newItem.type === 'plat' ? 'Plat' : 'Boisson'}
                          onChange={(e) => {
                            if (newItem.type === 'plat') {
                              setNewItem({...newItem, plat: e.target.value});
                            } else {
                              setNewItem({...newItem, boisson: e.target.value});
                            }
                          }}
                        >
                          {(newItem.type === 'plat' ? plats : boissons).map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.nom} - {item.prix.toFixed(2)} 
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                      <TextField
                        label="Quantité"
                        type="number"
                        fullWidth
                        value={newItem.quantite}
                        onChange={(e) => setNewItem({...newItem, quantite: parseInt(e.target.value) || 1})}
                        InputProps={{ inputProps: { min: 1 } }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} md={3}>
                      <Box display="flex" gap={1} height="100%" alignItems="flex-end">
                        <Button
                          variant="contained"
                          onClick={handleAddItem}
                          fullWidth
                        >
                          Ajouter
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => setAddingItem(false)}
                        >
                          Annuler
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              )}

              {items.length > 0 ? (
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell align="right">Prix unitaire</TableCell>
                        <TableCell align="right">Quantité</TableCell>
                        <TableCell align="right">Total</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <Typography>{item.nom}</Typography>
                            {item.notes && (
                              <Typography variant="body2" color="textSecondary">
                                {item.notes}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="right">
                            {item.prix_unitaire.toFixed(2)} 
                          </TableCell>
                          <TableCell align="right">{item.quantite}</TableCell>
                          <TableCell align="right">
                            <Typography fontWeight="bold">
                              {item.total.toFixed(2)} 
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleRemoveItem(index)}
                            >
                              <Delete />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell colSpan={3} align="right">
                          <Typography fontWeight="bold">Total:</Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="h6" color="primary">
                            {totalAmount.toFixed(2)} 
                          </Typography>
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Alert severity="info">
                  Aucun item ajouté à la commande. Cliquez sur "Ajouter un item" pour commencer.
                </Alert>
              )}
            </Box>
          )}

          {activeStep === 2 && (
            <Box>
              <Typography variant="h6" gutterBottom>Récapitulatif de la commande</Typography>
              
              <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="textSecondary">Type de commande:</Typography>
                    <Typography variant="body1">
                      <Box display="flex" alignItems="center" gap={1}>
                        {getTypeCommandeIcon(formData.type_commande)}
                        {getTypeCommandeLabel(formData.type_commande)}
                      </Box>
                    </Typography>
                  </Grid>
                  
                  {formData.type_commande === 'sur_place' && formData.table && (
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" color="textSecondary">Table:</Typography>
                      <Typography variant="body1">
                        Table {getTableNumber(formData.table)}
                      </Typography>
                    </Grid>
                  )}
                  
                  {formData.type_commande !== 'sur_place' && formData.nom_client && (
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" color="textSecondary">Client:</Typography>
                      <Typography variant="body1">{formData.nom_client}</Typography>
                    </Grid>
                  )}
                  
                  {formData.notes && (
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" color="textSecondary">Notes:</Typography>
                      <Typography variant="body1">{formData.notes}</Typography>
                    </Grid>
                  )}
                  
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                      Items ({totalItems} articles):
                    </Typography>
                    <List dense>
                      {items.map((item, index) => (
                        <ListItem key={index} divider={index < items.length - 1}>
                          <ListItemText
                            primary={`${item.quantite}x ${item.nom}`}
                            secondary={`${item.prix_unitaire.toFixed(2)}  × ${item.quantite} = ${item.total.toFixed(2)} `}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                  
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                      <Typography variant="h6">Total:</Typography>
                      <Typography variant="h4" color="primary">
                        {totalAmount.toFixed(2)} 
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
              
              <Alert severity="info" sx={{ mb: 2 }}>
                Vérifiez les informations avant de créer la commande.
              </Alert>
            </Box>
          )}
        </DialogContent>
        
        <DialogActions sx={{ borderTop: 1, borderColor: 'divider', p: 2 }}>
          <Button
            onClick={() => activeStep > 0 ? handlePrevStep() : setOpenDialog(false)}
            variant="outlined"
          >
            {activeStep > 0 ? 'Retour' : 'Annuler'}
          </Button>
          
          <Button
            onClick={activeStep < steps.length - 1 ? handleNextStep : handleSubmit}
            variant="contained"
            disabled={submitting || (activeStep === 1 && items.length === 0)}
            startIcon={submitting ? <CircularProgress size={20} /> : null}
          >
            {submitting ? 'Enregistrement...' : 
             activeStep < steps.length - 1 ? 'Suivant' : 
             isEditing ? 'Modifier' : 'Créer'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de détails */}
      {selectedCommande && (
        <Dialog
          open={openDetailsDialog}
          onClose={() => setOpenDetailsDialog(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: 2 } }}
        >
          <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Receipt />
              <Typography variant="h6">
                Détails de la commande {selectedCommande.numero}
              </Typography>
            </Box>
          </DialogTitle>
          
          <DialogContent>
            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="textSecondary">Statut:</Typography>
                <Chip
                  icon={getStatutIcon(selectedCommande.statut)}
                  label={getStatutLabel(selectedCommande.statut)}
                  color={getStatutColor(selectedCommande.statut)}
                  sx={{ mt: 0.5 }}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="textSecondary">Type:</Typography>
                <Typography variant="body1">
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    {getTypeCommandeIcon(selectedCommande.type_commande)}
                    {getTypeCommandeLabel(selectedCommande.type_commande)}
                  </Box>
                </Typography>
              </Grid>
              
              {selectedCommande.table && (
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="textSecondary">Table:</Typography>
                  <Typography variant="body1">
                    <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                      <TableRestaurant />
                      Table {getTableNumber(selectedCommande.table)}
                    </Box>
                  </Typography>
                </Grid>
              )}
              
              {selectedCommande.nom_client && (
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="textSecondary">Client:</Typography>
                  <Typography variant="body1">
                    <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                      <Person />
                      {selectedCommande.nom_client}
                    </Box>
                  </Typography>
                </Grid>
              )}
              
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">Date:</Typography>
                <Typography variant="body1">
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    <Schedule />
                    {formatDate(selectedCommande.date_commande)}
                  </Box>
                </Typography>
              </Grid>
              
              {selectedCommande.notes && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">Notes:</Typography>
                  <Typography variant="body1" sx={{ mt: 0.5, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
                    {selectedCommande.notes}
                  </Typography>
                </Grid>
              )}
              
              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Typography variant="h6" gutterBottom>Détails financiers</Typography>
                
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="textSecondary">Sous-total:</Typography>
                    <Typography variant="h6">
                      {parseFloat(selectedCommande.sous_total || 0).toFixed(2)} 
                    </Typography>
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="textSecondary">Remise:</Typography>
                    <Typography variant="h6" color="error">
                      -{parseFloat(selectedCommande.remise || 0).toFixed(2)} 
                    </Typography>
                  </Grid>
                  
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">Total:</Typography>
                    <Typography variant="h4" color="primary">
                      {parseFloat(selectedCommande.montant_total || 0).toFixed(2)} 
                    </Typography>
                  </Grid>
                  
                  {selectedCommande.statut === 'payee' && (
                    <>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary">Méthode de paiement:</Typography>
                        <Typography variant="body1">
                          <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                            {getMethodePaiementIcon(selectedCommande.methode_paiement)}
                            {getMethodePaiementLabel(selectedCommande.methode_paiement)}
                          </Box>
                        </Typography>
                      </Grid>
                      
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary">Montant reçu:</Typography>
                        <Typography variant="body1">
                          {parseFloat(selectedCommande.montant_recu || 0).toFixed(2)} 
                        </Typography>
                      </Grid>
                      
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary">Monnaie rendue:</Typography>
                        <Typography variant="body1">
                          {parseFloat(selectedCommande.monnaie || 0).toFixed(2)} 
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          
          <DialogActions sx={{ borderTop: 1, borderColor: 'divider', p: 2 }}>
            <Button onClick={() => setOpenDetailsDialog(false)} variant="outlined">
              Fermer
            </Button>
            {selectedCommande.statut === 'servie' && (
              <Button
                variant="contained"
                startIcon={<Paid />}
                onClick={() => {
                  setOpenDetailsDialog(false);
                  handleOpenPaiement(selectedCommande);
                }}
              >
                Payer
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}

      {/* Dialog de paiement */}
      {selectedCommande && (
        <Dialog
          open={openPaiementDialog}
          onClose={() => !submitting && setOpenPaiementDialog(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: 2 } }}
        >
          <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Paid />
              <Typography variant="h6">Paiement de la commande {selectedCommande.numero}</Typography>
            </Box>
          </DialogTitle>
          
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">Montant à payer:</Typography>
                  <Typography variant="h4" color="primary" sx={{ mt: 1 }}>
                    {parseFloat(selectedCommande.montant_total || 0).toFixed(2)} 
                  </Typography>
                </Grid>
                
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Méthode de paiement</InputLabel>
                    <Select
                      value={paiementData.methode_paiement}
                      label="Méthode de paiement"
                      onChange={(e) => setPaiementData({...paiementData, methode_paiement: e.target.value})}
                      disabled={submitting}
                    >
                      {methodePaiementOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Box display="flex" alignItems="center" gap={1}>
                            {option.icon}
                            {option.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    label="Montant reçu"
                    type="number"
                    fullWidth
                    value={paiementData.montant_recu}
                    onChange={(e) => {
                      const montant = e.target.value;
                      setPaiementData({
                        ...paiementData,
                        montant_recu: montant,
                        monnaie: parseFloat(montant || 0) - parseFloat(selectedCommande.montant_total || 0)
                      });
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end"></InputAdornment>,
                      inputProps: { step: "0.01", min: "0" }
                    }}
                    disabled={submitting}
                  />
                </Grid>
                
                {paiementData.montant_recu && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">Monnaie à rendre:</Typography>
                    <Typography
                      variant="h5"
                      color={paiementData.monnaie >= 0 ? "success.main" : "error.main"}
                      sx={{ mt: 1 }}
                    >
                      {paiementData.monnaie.toFixed(2)} 
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          </DialogContent>
          
          <DialogActions sx={{ borderTop: 1, borderColor: 'divider', p: 2 }}>
            <Button
              onClick={() => setOpenPaiementDialog(false)}
              variant="outlined"
              disabled={submitting}
            >
              Annuler
            </Button>
            <Button
              onClick={handlePaiement}
              variant="contained"
              disabled={submitting || !paiementData.montant_recu || 
                       parseFloat(paiementData.montant_recu) < parseFloat(selectedCommande.montant_total || 0)}
              startIcon={submitting ? <CircularProgress size={20} /> : <Paid />}
            >
              {submitting ? 'Enregistrement...' : 'Enregistrer le paiement'}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default CommandesPage;